module.exports = __webpack_public_path__ + "img/292.5ebf3540.jpg";